import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Assignee from 'components/sales/formSection/assignee/assignee';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const MaintenanceChangeAssignee = ({
  getAssigneeList,
  assigneeList,
  match,
  postAssignee,
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setsiteId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const inputs = {
    assigneeDetail: null,
  };
  const [smAssign, setSmAssign] = useState(inputs);
  useEffect(() => {
    setsiteId(match.params.siteId);
    (async () => {
      if (siteId) {
        setIsLoading(true);
        await getAssigneeList(siteId);
        setIsLoading(false);
      }
    })();
  }, [siteId]);

  const handleAssignee = (val) => {
    setSmAssign({ ...smAssign, assigneeDetail: val });
  };
  const handleModalHide = () => setIsModal(false);
  const handleSubmit = async () => {
    const { assigneeDetail } = smAssign;
    if (assigneeDetail === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      setIsModal(true);
      setIsLoading(true);
      const res = await postAssignee(assigneeDetail);
      setIsLoading(false);
      if (res) getAssigneeList(siteId);
    }
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  return (
    <Layout
      title={localization.changeAssignee}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/site-maintenance-user`}
    >
      <Assignee
        assigneeList={assigneeList}
        siteId={siteId}
        handleValue={handleAssignee}
        isBulkAssignment={true}
        baAssignee={true}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/brand-activation/site-maintenance-user`}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

MaintenanceChangeAssignee.propTypes = {};

export default MaintenanceChangeAssignee;
